export const fromRuntime = (key) => {
    if (!window.__RUNTIME_CONFIG__ || !(key in window.__RUNTIME_CONFIG__)) {
        throw new Error(
            '[runtime-config] "' +
                key +
                '" is missing from window.__RUNTIME_CONFIG__. ' +
                'Verify the container entrypoint generated runtime-config.js correctly.',
        );
    }
    return window.__RUNTIME_CONFIG__[key];
};
